var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('div',{staticClass:"border transition-duration-400 rounded-lg border-gray-300 bg-gray-200 p-4 text-center text-lg font-medium text-gray-800 shadow-sm transition-all"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }